import React from 'react';
import UserCard from '@/components/UserCard';
import CalcRadish from '$/components/CalcRadish';
import { useOfficialStore } from '$/store/useOfficialStore';
import styles from './index.module.scss';

/**
 * AI Flow 页面右上角用户区域；未登录仅展示用户卡片，已登录额外展示萝卜余额
 */
export default function RightHeader() {
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());

  if (!isUserLoggedIn) {
    return (
      <UserCard style={{
        height: '50px',
        position: 'fixed',
        top: 16,
        right: 16,
      }}
      />
    );
  }

  return (
    <div className={styles.userCardBox}>
      {/* 发布社区 */}
      <div id="flowPublishCommunity" />
      {/* 分享 */}
      <div id="flowShareBtn" />
      {/* 萝卜余额 */}
      <CalcRadish />
      {/* 用户卡片 */}
      <UserCard style={{ height: '100%' }} />
    </div>
  );
}
